"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SwapType = exports.RankEnum = void 0;
var RankEnum;
(function (RankEnum) {
    RankEnum["president"] = "P";
    RankEnum["vicepresident"] = "VP";
    RankEnum["unranked"] = "-";
    RankEnum["viceasshole"] = "VA";
    RankEnum["asshole"] = "A";
})(RankEnum = exports.RankEnum || (exports.RankEnum = {}));
var SwapType;
(function (SwapType) {
    SwapType[SwapType["high"] = 0] = "high";
    SwapType[SwapType["low"] = 1] = "low";
})(SwapType = exports.SwapType || (exports.SwapType = {}));
//# sourceMappingURL=types.js.map